import React from 'react';

function ExtraScrumBoard() {
	return (
		<div>
			<div className="d-flex align-items-center mb-2">
							<div>
								<ol className="breadcrumb">
									<li className="breadcrumb-item"><a href="#/">Home</a></li>
									<li className="breadcrumb-item"><a href="#/">Pages</a></li>
									<li className="breadcrumb-item active"></li>
								</ol>
								
								<h1 className="page-header mb-0">
									Scrum Board 
								</h1>
								
							</div>
							<div className="ms-auto">
								<a href="#modalAddTask" data-bs-toggle="modal" className="btn btn-dark px-4">
									<i className="fa fa-plus fa-lg me-1 ms-n2 opacity-5"></i> Add Task
								</a>
							</div>
						</div>
						
						<div className="mb-3 d-md-flex gap-4 fw-bold py-1">
							<div className="dropdown-toggle">
								<a href="#/" data-bs-toggle="dropdown" className="text-decoration-none d-flex align-items-center gap-2 link-dark">
									<iconify-icon icon="solar:folder-with-files-outline" className="fs-4"></iconify-icon> project/color-admin <b className="caret ms-0"></b>
								</a>
								<div className="dropdown-menu dropdown-menu-start">
									<a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> project/mobile-app-dev</a>
									<a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> project/bootstrap-5</a>
									<a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> project/mvc-version</a>
									<a href="#/" className="dropdown-item"><i className="far fa-folder fa-fw fa-lg text-gray-500 me-1"></i> project/ruby-version</a>
								</div>
							</div>
							<div className="mt-md-0 mt-2 d-flex align-items-center gap-2">
								<iconify-icon icon="solar:routing-outline" className="fs-4"></iconify-icon>
								1,392 pull request
							</div>
							<div className="mt-md-0 mt-2 d-flex align-items-center gap-2">
								<iconify-icon icon="solar:users-group-rounded-outline" className="fs-4"></iconify-icon>
								52 participant
							</div>
							<div className="mt-md-0 mt-2 d-flex align-items-center gap-2">
								<iconify-icon icon="solar:clock-circle-outline" className="fs-4"></iconify-icon> 
								14 day(s)
							</div>
						</div>
						
						<div className="row g-3">
							<div className="col-xxl-4 col-xl-6">
								<div className="card card-borderless">
									<div className="card-header bg-gray-900">
										<h4 className="card-header-title text-white">To do (5)</h4>
										<div className="card-header-btn">
											<a href="#/" className="btn btn-xs btn-icon btn-default" data-toggle="card-expand"><i className="fa fa-expand"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-success" data-toggle="card-reload"><i className="fa fa-redo"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-warning" data-toggle="card-collapse"><i className="fa fa-minus"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-danger" data-toggle="card-remove"><i className="fa fa-times"></i></a>
										</div>
									</div>
									
									<div className="list-group list-group-flush">
										<div className="list-group-item border-0 d-flex gap-3">
											<div className="fs-3 text-body text-opacity-50 d-flex">
												<iconify-icon icon="solar:question-circle-line-duotone"></iconify-icon>
											</div>
											<div className="flex-fill">
												<div className="fw-bold">Enable open search</div>
												<div className="mb-1 small fw-semibold text-secondary">
													#29949 opened yesterday by Terry
												</div>
												<div className="mb-3 pb-1">
													<span className="badge bg-blue">docs</span>
													<span className="badge bg-body text-body">feature</span>
												</div>
												<hr />
												<div className="d-flex gap-2 align-items-center mb-2">
													<div className="fw-bold small">Task (2/3)</div>
													<div className="progress h-6px w-100px">
														<div className="progress-bar progress-bar-striped" style={{ width: '66%' }}></div>
													</div>
													<div className="fw-bold text-secondary small">66%</div>
													<div className="ms-auto my-n2">
														<a href="#/" className="btn btn-default btn-xs fs-11px rounded-pill px-2" data-bs-toggle="collapse" data-bs-target="#todoBoard">
															collapse
														</a>
													</div>
												</div>
												<div className="form-group small">
													<div className="collapse show" id="todoBoard">
														<div className="form-check mb-1">
													<input type="checkbox" className="form-check-input" id="customCheck1" defaultChecked />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck1">create ui for autocomplete</label>
														</div>
														<div className="form-check mb-1">
													<input type="checkbox" className="form-check-input" id="customCheck2" defaultChecked />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck2">integrate jquery autocomplete with ui</label>
														</div>
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="customCheck3" />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck3">backend search return as json data</label>
														</div>
													</div>
												</div>
											</div>
										</div>
										<hr className="m-0" />
										<a href="#/" className="list-group-item border-0 d-flex gap-3">
											<div className="fs-3 text-body text-opacity-50 d-flex">
												<iconify-icon icon="solar:question-circle-line-duotone"></iconify-icon>
											</div>
											<div className="flex-fill">
												<div className="fw-bold">Investigate adding markdownlint</div>
												<div className="mb-1 small fw-semibold text-secondary">#29919 opened 9 days ago by xMediaKron</div>
												<div className="mb-2">
													<span className="badge bg-body text-body">build</span>
													<span className="badge bg-indigo">v5</span>
												</div>
											</div>
										</a>
										<hr className="m-0" />
										<a href="#/" className="list-group-item border-0 d-flex gap-3">
											<div className="fs-3 text-body text-opacity-50 d-flex">
												<iconify-icon icon="solar:question-circle-line-duotone"></iconify-icon>
											</div>
											<div className="flex-fill">
												<div className="fw-bold">Add a "Submit a Resource" form</div>
												<div className="mb-1 small fw-semibold text-secondary">#29916 opened 9 days ago by Wasbbok</div>
												<div className="mb-2 d-flex align-items-center">
													<div className="me-2"><span className="badge bg-success">enhancement</span></div>
													<div className="d-flex pt-2px">
														<div className="widget-img widget-img-xs rounded-circle bg-dark me-n1" style={{ backgroundImage: 'url(/color-admin/admin/react/assets/img/user/user-1.jpg)' }}>
														</div>
														<div className="widget-img widget-img-xs rounded-circle bg-dark me-n1" style={{ backgroundImage: 'url(/color-admin/admin/react/assets/img/user/user-2.jpg)' }}>
														</div>
														<div className="widget-img widget-img-xs rounded-circle bg-dark me-n1" style={{ backgroundImage: 'url(/color-admin/admin/react/assets/img/user/user-3.jpg)' }}>
														</div>
														<div className="widget-icon widget-icon-xs rounded-circle bg-body text-body fs-10px fw-bolder">
															+2
														</div>
													</div>
												</div>
											</div>
										</a>
										<hr className="m-0" />
										<a href="#/" className="list-group-item border-0 d-flex gap-3">
											<div className="fs-3 text-body text-opacity-50 d-flex">
												<iconify-icon icon="solar:question-circle-line-duotone"></iconify-icon>
											</div>
											<div className="flex-fill">
												<div className="fw-bold">Custom control border color missing on focus</div>
												<div className="mb-1 small fw-semibold text-secondary">#29796 opened 29 days ago by mdo</div>
												<div className="mb-2">
													<span className="badge bg-primary">docs</span>
												</div>
											</div>
										</a>
										<hr className="m-0" />
										<a href="#/" className="list-group-item border-0 d-flex gap-3">
											<div className="fs-3 text-body text-opacity-50 d-flex">
												<iconify-icon icon="solar:question-circle-line-duotone"></iconify-icon>
											</div>
											<div className="flex-fill">
												<div className="fw-bold">New design for corporate page</div>
												<div className="mb-1 small fw-semibold text-secondary">#29919 opened 19 days ago by sean</div>
												<div className="mb-2">
													<span className="badge bg-body text-body">design</span>
													<span className="badge bg-primary">v5</span>
												</div>
											</div>
										</a>
									</div>
								</div>
							</div>
							<div className="col-xxl-4 col-xl-6">
								<div className="card card-borderless">
									<div className="card-header bg-gray-900">
										<h4 className="card-header-title text-white">In Progress (2)</h4>
										<div className="card-header-btn">
											<a href="#/" className="btn btn-xs btn-icon btn-default" data-toggle="card-expand"><i className="fa fa-expand"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-success" data-toggle="card-reload"><i className="fa fa-redo"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-warning" data-toggle="card-collapse"><i className="fa fa-minus"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-danger" data-toggle="card-remove"><i className="fa fa-times"></i></a>
										</div>
									</div>
									<div className="list-group list-group-flush rounded-bottom overflow-hidden panel-body p-0">
										<div className="list-group-item border-0 d-flex gap-3">
											<div className="fs-3 text-body text-opacity-50 d-flex">
												<iconify-icon icon="solar:settings-linear"></iconify-icon>
											</div>
											<div className="flex-fill">
												<div className="fw-bold">HTML5 flexbox old browser compatibility</div>
												<div className="mb-1 small fw-semibold text-secondary">#29982 handled by Sean</div>
												<div className="mb-3 pb-1">
													<span className="badge bg-indigo">enhancement</span>
												</div>
												<hr />
												<div className="d-flex gap-2 align-items-center mb-2">
													<div className="fw-bold small">
														Task (1/2)
													</div>
													<div className="progress h-6px w-100px">
														<div className="progress-bar progress-bar-striped bg-warning" style={{ width: '50%' }}></div>
													</div>
													<div className="fw-bold text-secondary small">50%</div>
													<div className="ms-auto my-n2">
														<a href="#/" className="btn btn-default btn-xs fs-11px rounded-pill px-2" data-bs-toggle="collapse" data-bs-target="#inProgressBoard">
															collapse
														</a>
													</div>
												</div>
												<div className="form-group small">
													<div className="collapse show" id="inProgressBoard">
														<div className="form-check mb-1">
													<input type="checkbox" className="form-check-input" id="customCheck4" defaultChecked />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck4">check all browser compatibility for HTML5 flexbox</label>
														</div>
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="customCheck5" />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck5">fallback integration by using other display property</label>
														</div>
													</div>
												</div>
											</div>
										</div>
										<hr className="m-0" />
										<div className="list-group-item border-0 d-flex gap-3">
											<div className="fs-3 text-body text-opacity-50 d-flex">
												<iconify-icon icon="solar:bug-line-duotone"></iconify-icon>
											</div>
											<div className="flex-fill">
												<div className="fw-bold">Mobile app autoclose on iOS</div>
												<div className="mb-1 small fw-semibold text-secondary">#29953 handled by Ken</div>
												<div className="mb-3 pb-1">
													<span className="badge bg-gray-300 text-gray-900">issue</span>
													<span className="badge bg-danger">bug</span>
												</div>
												<hr />
												<div className="d-flex gap-2 align-items-center mb-2">
													<div className="fw-bold small">
														Task (0/1)
													</div>
													<div className="progress h-6px w-100px">
														<div className="progress-bar progress-bar-striped bg-danger" style={{ width: '5%' }}></div>
													</div>
													<div className="fw-bold text-secondary small">0%</div>
													<div className="ms-auto my-n2">
														<a href="#/" className="btn btn-default btn-xs fs-11px rounded-pill px-2" data-bs-toggle="collapse" data-bs-target="#inProgress2Board">
															collapse
														</a>
													</div>
												</div>
												<div className="form-group small">
													<div className="collapse show" id="inProgress2Board">
														<div className="form-check">
															<input type="checkbox" className="form-check-input" id="customCheck6" />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck6">debug and fix mobile auto close while using GPS issue</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xxl-4 col-xl-6">
								<div className="card card-borderless">
									<div className="card-header bg-gray-900">
										<h4 className="card-header-title text-white">Done (1)</h4>
										<div className="card-header-btn">
											<a href="#/" className="btn btn-xs btn-icon btn-default" data-toggle="card-expand"><i className="fa fa-expand"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-success" data-toggle="card-reload"><i className="fa fa-redo"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-warning" data-toggle="card-collapse"><i className="fa fa-minus"></i></a>
											<a href="#/" className="btn btn-xs btn-icon btn-danger" data-toggle="card-remove"><i className="fa fa-times"></i></a>
										</div>
									</div>
									<div className="list-group list-group-flush rounded-bottom overflow-hidden panel-body p-0">
										<div className="list-group-item border-0 d-flex gap-3">
											<div className="fs-3 text-body text-opacity-50 d-flex">
												<iconify-icon icon="solar:check-circle-line-duotone"></iconify-icon>
											</div>
											<div className="flex-fill">
												<div className="fw-bold">React version missing daterangepicker</div>
												<div className="mb-1 small fw-semibold text-secondary">#29930 closed yesterday by Sean</div>
												<div className="mb-3 pb-1">
													<span className="badge bg-body text-body">build</span>
													<span className="badge bg-success">feature</span>
												</div>
												<hr />
												<div className="d-flex gap-2 align-items-center mb-2">
													<div className="fw-bold small">Task (3/3)</div>
													<div className="progress h-6px w-100px">
														<div className="progress-bar progress-bar-striped bg-success" style={{ width: '100%' }}></div>
													</div>
													<div className="fw-bold text-secondary small">100%</div>
													<div className="ms-auto my-n2">
														<a href="#/" className="btn btn-default btn-xs fs-11px rounded-pill px-2" data-bs-toggle="collapse" data-bs-target="#completedBoard">
															collapse
														</a>
													</div>
												</div>
												<div className="form-group small">
													<div className="collapse show" id="completedBoard">
														<div className="form-check mb-1">
													<input type="checkbox" className="form-check-input" id="customCheck7" defaultChecked />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck7">install react-daterangepicker</label>
														</div>
														<div className="form-check mb-1">
													<input type="checkbox" className="form-check-input" id="customCheck8" defaultChecked />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck8">customize ui with scss</label>
														</div>
														<div className="form-check">
													<input type="checkbox" className="form-check-input" id="customCheck9" defaultChecked />
															<label className="form-check-label fw-semibold text-body text-opacity-85" htmlFor="customCheck9">backend integration for data filter with daterange input</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
		</div>
	);
}

export default ExtraScrumBoard;
